import { getBundleResources, mapActorResource } from "./fhir.utils";
import {
  ActorModel,
  FhirClientPort,
  PatientResource,
} from "./fhir.types";

export class PatientService {
  constructor(private readonly client: FhirClientPort) {}

  async searchByEmail(email: string): Promise<ActorModel[]> {
    const bundle = await this.client.search("Patient", {
      email: email.trim(),
      active: true,
      _count: 100,
    });

    return getBundleResources<PatientResource>(bundle, "Patient").map(
      mapActorResource,
    );
  }

  async searchByName(query: string): Promise<ActorModel[]> {
    const normalized = query.trim();
    const bundle = await this.client.search("Patient", {
      ...(normalized ? { name: normalized } : {}),
      active: true,
      _count: 100,
    });

    return getBundleResources<PatientResource>(bundle, "Patient").map(
      mapActorResource,
    );
  }
}
